import { toastr } from "react-redux-toastr";
import { ORDERS_ACTION_TYPES } from "./actionTypes";
import { ordersApi } from "./api";
import { cartActions } from "../cart";
import { promoActions } from "../promo";
import { bonusesActions } from "../bonuses";

export const ordersActions = {
    putOrderRequest: () => ({
        type: ORDERS_ACTION_TYPES.PUT_ORDER_REQUEST,
    }),

    putOrderSuccess: (data) => ({
        type: ORDERS_ACTION_TYPES.PUT_ORDER_SUCCESS,
        payload: data,
        meta: { timestamp: Date.now() },
    }),

    putOrderFailure: (error) => ({
        type: ORDERS_ACTION_TYPES.PUT_ORDER_FAILURE,
        payload: { error },
        error: true,
    }),

    fetchOrderRequest: () => ({
        type: ORDERS_ACTION_TYPES.FETCH_ORDER_REQUEST,
    }),

    fetchOrderSuccess: (data) => ({
        type: ORDERS_ACTION_TYPES.FETCH_ORDER_SUCCESS,
        payload: data,
    }),

    fetchOrderFailure: (error) => ({
        type: ORDERS_ACTION_TYPES.FETCH_ORDER_FAILURE,
        payload: { error },
        error: true,
    }),

    clearOrderState: () => ({
        type: ORDERS_ACTION_TYPES.CLEAR_ORDER_STATE,
    }),
};

export const putOrder = (orderData, onSuccess) => {
    return async (dispatch, getState) => {
        const state = getState();

        if (state.orders?.loading) {
            return;
        }

        dispatch(ordersActions.putOrderRequest());

        const token = state.auth?.token;

        try {
            const result = await ordersApi.createOrder(orderData, token);

            if (result.success) {
                const orderWithPayment = {
                    ...result.data,
                    payment_method: result.data.payment_method || orderData.payment_option,
                };
                dispatch(ordersActions.putOrderSuccess(orderWithPayment));

                dispatch(cartActions.clearCart());
                if (promoActions?.clearPromo) {
                    dispatch(promoActions.clearPromo());
                }
                if (bonusesActions?.clearPoints) {
                    dispatch(bonusesActions.clearPoints());
                }

                toastr.success(
                    'Заказ оформлен!',
                    `Номер заказа: ${result.data.order_number}`
                );

                if (onSuccess) {
                    onSuccess(result.data);
                }

                return result.data;
            } else {
                dispatch(ordersActions.putOrderFailure(result.message));
                toastr.error('Ошибка', result.message);
            }
        } catch (error) {
            console.error('Create order error:', error);
            dispatch(ordersActions.putOrderFailure('Ошибка при создании заказа'));
            toastr.error('Ошибка', 'Не удалось создать заказ. Попробуйте позже.');
        }
    };
};

export const fetchOrder = (orderId) => {
    return async (dispatch) => {
        dispatch(ordersActions.fetchOrderRequest());

        try {
            const order = await ordersApi.fetchOrder(orderId);
            dispatch(ordersActions.fetchOrderSuccess(order));
        } catch (error) {
            console.error('Fetch order error:', error);
            dispatch(ordersActions.fetchOrderFailure('Ошибка получения заказа'));
        }
    };
};
